/**
 * Location Suggestions Dropdown Hook
 * Consolidates related logic for the location suggestions dropdown.
 */
import { useState } from "react";
import { useDebouncedState } from "@react-hookz/web";
// TODO: Figure out why the `paths` `@/*` alias in tsconfig.json doesn't work
import { useLocationSuggestionsQuery } from "../../generated/graphql.jsx";
import { getDropdownData } from "./functions/getDropdownData.jsx";
const MIN_SEARCH_TERM_LENGTH = 3;
export function useLocationSuggestionsDropdown(props) {
    const { initialLocation = "" } = props || {};
    const [selectedLocation, setSelectedLocation] = useState(initialLocation);
    const [searchTerm, setSearchTerm] = useDebouncedState("", 150, 500);
    const { data: queryData, error } = useLocationSuggestionsQuery({
        variables: { searchTerm },
        skip: searchTerm.length < MIN_SEARCH_TERM_LENGTH,
    });
    const locations = queryData?.locationSuggestions.postcodes;
    const data = getDropdownData({
        searchTermLength: searchTerm.length,
        selectedLocation,
        locations,
        error,
    });
    return {
        searchTerm,
        selectedLocation,
        setSearchTerm,
        setSelectedLocation,
        data,
        locations,
    };
}
